import { useDispatch, useSelector } from 'react-redux';

import { useEffectSafeStrictMode } from 'hooks/useEffectSafeStrictMode';

import { getFormsInfoAction } from 'store/forms/actions';
import { selectIsFormsInfoLoaded } from 'store/forms/selectors';

// Re-dispatches whenever the reducer invalidates formsInfo (form CRUD, identity swap),
// so pickers self-heal instead of staying empty until the page remounts.
const useFormsInfoLoader = (isEnabled = true) => {
  const dispatch = useDispatch();
  const isFormsInfoLoaded = useSelector(selectIsFormsInfoLoaded);

  useEffectSafeStrictMode(() => {
    if (isEnabled && !isFormsInfoLoaded) {
      dispatch(getFormsInfoAction());
    }
  }, [dispatch, isEnabled, isFormsInfoLoaded]);
};

export default useFormsInfoLoader;
